import styled, { css } from 'styled-components';
import { BadgeOverlay, Spinner } from 'react-rainbow-components';
import ButtonIcon from 'components/ButtonIcon';
import {
    DIVIDER,
    GREY_400,
    GREY_500,
    GREY_700,
    GREY_800,
    HIGHLIGHT,
    PURPLE_500,
    WHITE,
} from '../../../constants';

export const NotificationMenuContainer = styled.div`
    position: relative;
    display: block;
`;

export const StyledButtonIcon = styled(ButtonIcon)`
    flex-shrink: 0;
`;

export const StyledSpinner = styled(Spinner)`
    position: relative;
    z-index: 1;
    top: unset;
    left: unset;
    transform: unset;
`;

export const StyledBadgeOverlay = styled(BadgeOverlay)`
    & > span {
        font-size: 10px;
        font-weight: 500;
        line-height: 11px;
        text-align: center;
        min-width: 18px;
        height: 18px;
    }
`;

export const DropdownContainer = styled.div`
    width: 360px;
    background: ${WHITE};
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06), 0px 8px 24px 0px rgba(75, 70, 92, 0.16);
    border-radius: 0.75rem;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 2rem);
    overflow: hidden;
`;

export const Header = styled.header`
    height: 3rem;
    padding: 0.75rem 1rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${DIVIDER};
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const Title = styled.p`
    margin: 0;
    color: ${GREY_800};
    font-size: 0.875rem;
    font-weight: 600;
`;

export const SoundToggleButton = styled.button`
    border: none;
    background: transparent;
    color: ${GREY_700};
    width: 1.5rem;
    height: 1.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    padding: 0;
    cursor: pointer;

    &:hover {
        background: ${HIGHLIGHT};
    }

    &:focus-visible {
        outline: 2px solid ${PURPLE_500};
        outline-offset: 1px;
    }
`;

export const MarkAllButton = styled.button`
    border: none;
    background: transparent;
    color: ${PURPLE_500};
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0;
    cursor: pointer;

    &:disabled {
        color: ${GREY_400};
        cursor: default;
    }
`;

export const NotificationsList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 22rem;
    overflow-y: auto;
`;

export const NotificationRow = styled.li`
    border-bottom: 1px solid ${DIVIDER};

    &:last-child {
        border-bottom: none;
    }
`;

export const NotificationButton = styled.div<{ $isUnread: boolean }>`
    width: 100%;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    text-align: left;

    ${(props) => props.$isUnread && css`
        background: ${HIGHLIGHT};
    `}

    &:hover {
        background: ${HIGHLIGHT};
    }

    &:focus-visible {
        outline: 2px solid ${PURPLE_500};
        outline-offset: -2px;
    }
`;

export const UnreadDot = styled.span<{ $isVisible: boolean }>`
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: ${PURPLE_500};
    margin-top: 0.35rem;
    flex-shrink: 0;
    opacity: ${(props) => (props.$isVisible ? 1 : 0)};
`;

export const NotificationContent = styled.div`
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
`;

export const NotificationTitle = styled.p<{ $isUnread: boolean }>`
    margin: 0;
    color: ${GREY_800};
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: ${(props) => (props.$isUnread ? 600 : 500)};
`;

export const NotificationSubtitle = styled.p`
    margin: 0;
    color: ${GREY_700};
    font-size: 0.75rem;
    line-height: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const NotificationDate = styled.p`
    margin: 0.125rem 0 0;
    color: ${GREY_500};
    font-size: 0.6875rem;
    line-height: 1rem;
`;

export const RowActions = styled.div`
    display: flex;
    align-items: center;
    margin-top: 0.125rem;
`;

export const MarkReadButton = styled.button`
    border: none;
    background: transparent;
    color: ${PURPLE_500};
    font-size: 0.6875rem;
    font-weight: 600;
    padding: 0;
    cursor: pointer;

    &:disabled {
        color: ${GREY_400};
        cursor: default;
    }
`;

export const EmptyState = styled.div`
    padding: 2.5rem 1rem;
    color: ${GREY_500};
    font-size: 0.875rem;
    text-align: center;
`;
